import { render } from "./DashboardSidebar.vue?vue&type=template&id=77e65d29&scoped=true&ts=true"
import script from "./DashboardSidebar.vue?vue&type=script&lang=ts"
export * from "./DashboardSidebar.vue?vue&type=script&lang=ts"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=77e65d29&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e65d29"]])

export default __exports__